window.addEventListener('DOMContentLoaded', () => {
  addEventListeners();
  positionMegaMenu();
});

window.addEventListener('resize', () => {
  positionMegaMenu();
});

function addEventListeners() {
  const header = document.querySelector('sticky-header');
  const toggleMegaMenuButton = document.querySelector('header-menu details');
  const megaMenu = document.querySelector('.mega-menu__content');

  toggleMegaMenuButton.addEventListener('mouseover', (event) => {
    expandMegaMenu(header, event.currentTarget);
  });

  megaMenu.addEventListener('mouseleave', (event) => {
    collapseMegaMenu(header, toggleMegaMenuButton);
  });
}

function expandMegaMenu(header, toggleMenuButton) {
  header.classList.add('header-wrapper--expanded');
  toggleMenuButton.setAttribute('open', '');
  toggleMenuButton.querySelector('summary').setAttribute('aria-expanded', 'true');
}

function collapseMegaMenu(header, toggleMenuButton) {
  header.classList.remove('header-wrapper--expanded');
  toggleMenuButton.removeAttribute('open');
  toggleMenuButton.querySelector('summary').setAttribute('aria-expanded', 'false');
}

function positionMegaMenu() {
  const megaMenuList = document.querySelector('.mega-menu__list');
  const headerMenu = document.querySelector('header-menu details');

  megaMenuList.style.transform = `translate(${headerMenu.getBoundingClientRect().left}px)`;
}